import { ConfirmModal } from "../primitives";
import type { TableColumn } from "../../lib/v3-columns";

interface ConfirmDeleteColumnModalProps {
  open: boolean;
  onClose: () => void;
  column: TableColumn | null;
  /** Total rows in the table. */
  rowCount: number;
  /** Rows that hold a non-empty value in this column — what's actually lost. */
  nonEmptyCount: number;
  onConfirm: () => Promise<void>;
}

/**
 * Sprint 14a — strong confirmation for an irreversible column delete. Surfaces
 * exactly how much data goes away (non-empty values across rows) before the
 * danger-styled confirm. Thin wrapper over the shared <ConfirmModal>.
 */
export function ConfirmDeleteColumnModal({
  open,
  onClose,
  column,
  rowCount,
  nonEmptyCount,
  onConfirm,
}: ConfirmDeleteColumnModalProps) {
  const name = column?.label ?? "";
  const message = (
    <>
      Deleting <strong style={{ color: "var(--color-text-primary)" }}>{name}</strong> will permanently delete{" "}
      {nonEmptyCount} value{nonEmptyCount === 1 ? "" : "s"} across {rowCount} row{rowCount === 1 ? "" : "s"}. This cannot
      be undone.
    </>
  );

  return (
    <ConfirmModal
      open={open}
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
      title={`Delete column "${name}"?`}
      message={message}
      confirmLabel="Delete column"
      variant="danger"
      onConfirm={onConfirm}
    />
  );
}
